module.exports = __webpack_public_path__ + "static/media/minimize.dc85cb39.svg";